export default {
  root: {
    marginBottom: 12,
  },
};
